var React = require('react');

function SectionTopBulgeMobile (props) {
    return React.createElement("svg",props,React.createElement("defs",null,React.createElement("clipPath",{"id":"section-top-bulge-mobile","clipPathUnits":"objectBoundingBox"},React.createElement("path",{"d":"M1,1 V0.029 C1,0.029,0.903,0,0.499,0 C0.095,0,0,0.029,0,0.029 V1 H1","fill":"#EEEEEE"}))));
}

SectionTopBulgeMobile.defaultProps = {"width":"0","height":"0","preserveAspectRatio":"none"};

module.exports = SectionTopBulgeMobile;

SectionTopBulgeMobile.default = SectionTopBulgeMobile;
